import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/aica.svg";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import FooterChatbot from "../components/FooterChatbot";

const LandingPage = () => {
  const navigate = useNavigate();
  const { setLang } = useContext(languageContext);
  const currentPagePath = window.location.pathname;

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const handleLanguageChange = (event) => {
    const selectedLanguageIndex = event.target.value;
    if (!selectedLanguageIndex) return;

    setLang(selectedLanguageIndex);
    localStorage.setItem("lang", selectedLanguageIndex);

    if (selectedLanguageIndex == 0) {
      localStorage.setItem("lang_name", "english");
    } else if (selectedLanguageIndex == 1) {
      localStorage.setItem("lang_name", "hindi");
    } else {
      localStorage.setItem("lang_name", "punjabi");
    }

    const loginBool = localStorage.getItem("login");

    navigate(loginBool === "true" ? "/ask" : "/login", {
      state: { url: currentPagePath },
    });
  };

  return (
    <div className="w-full min-h-screen flex flex-col justify-between items-center bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 p-4 sm:p-6 relative overflow-hidden">

      {/* Background Circles (UNCHANGED) */}
      <div className="absolute w-[250px] sm:w-[450px] h-[250px] sm:h-[450px] bg-green-300 opacity-30 rounded-full top-[10%] left-[5%] animate-pulse"></div>
      <div className="absolute w-[180px] sm:w-[300px] h-[180px] sm:h-[300px] bg-teal-300 opacity-40 rounded-full bottom-[10%] right-[5%] animate-pulse"></div>

      {/* MAIN CONTENT */}
      <div className="flex flex-col justify-center items-center flex-1 text-center z-10">

        {/* Logo */}
        <div className="flex flex-col items-center mb-6 sm:mb-8 animate-fadeIn">
          <img
            className="w-28 sm:w-40 md:w-52 lg:w-60 mb-4 drop-shadow-lg"
            src={logo}
            alt="frontPagePic"
          />

          <h1 className="text-white font-bold text-2xl sm:text-4xl md:text-5xl lg:text-6xl">
            Hi! Welcome to AICA
          </h1>
        </div>

        {/* Subtitle */}
        <p className="text-white text-sm sm:text-lg md:text-xl lg:text-2xl mb-5 sm:mb-6 font-medium">
          Please choose your preferred language
        </p>

        {/* Language Selector */}
        <div className="w-full max-w-xs sm:max-w-md">
          <select
            onChange={handleLanguageChange}
            className="bg-white border-2 border-[#A6C7E3] w-full py-2 sm:py-3 px-3 sm:px-4 rounded-lg text-gray-800 shadow-md
            focus:outline-none focus:ring-2 focus:ring-[#A8D4E7] transition hover:scale-105 cursor-pointer text-sm sm:text-base"
          >
            <option value="">Select Language</option>
            {data.map((language) => (
              <option key={language.index} value={language.index}>
                {capitalizeFirstLetter(language.name)}
              </option>
            ))}
          </select>
        </div>

      </div>

      {/* FOOTER (RESPONSIVE FIX ONLY) */}
      <footer className="w-full mt-6 z-10">

        <div className="bg-black/20 text-white text-center py-4 px-3">

          <p className="text-xs sm:text-sm">
            Powered by <span className="font-semibold">AICA</span> | Your Smart Health Assistant
          </p>

          {/* LINKS (FIXED RESPONSIVE WRAP) */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mt-3 text-[10px] sm:text-xs px-2">
            {[
  { label: "Terms and Conditions", href: "/terms" },
  { label: "Refund Policy", href: "/refund" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Privacy Notice", href: "/privacy-notice" },
  { label: "Disclaimer", href: "/disclaimer" },
  { label: "Services", href: "/services" },
  { label: "Master Privacy Policy", href: "/master_privacy" },
  { label: "Consent Policy", href: "/consent_policy" },
  { label: "Medical Disclaimer", href: "/medical_disclaimer" },
  { label: "AI Disclaimer", href: "/AI_disclaimer" },
  { label: "Cookie Policy", href: "/cookie_policy" },
  { label: "Data Retention Policy", href: "/Data_retention_policy" },
  { label: "Regulatory Disclaimer", href: "/regulatory_disclaimer" },
  { label: "User Manual", href: "/user_manual" },
  { label: "Contact Us", href: "/contact" },
].map((item, i) => (
  <a
    key={i}
    href={item.href}
    className="hover:underline opacity-80 hover:opacity-100 transition"
  >
    {item.label}
  </a>
))}

          </div>
        </div>

      </footer>

      <FooterChatbot />
    </div>
  );
};

export default LandingPage;